angular.module('myApp.services')
    .factory("tokensStorage", function() {
        let t = null;
        return {
            setToken: function(token) {
                t = token;
            },
            getToken: function() {
                return t;
            }
        }
    });